import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "product"

class service {

    selectList(params) {
        return http.list(path + "/selectList", params);
    }

    getResume(type, param, allStatus = false) {

        return http.getResume(path,type,param,allStatus);

    }

    getImages(id, type = "I", relation = "all") {

        let params = new URLSearchParams()
        params.append("productId", id)
        params.append("type", type)
        params.append("relation", relation)

        return http.list(path + "/getImages", params);


    }
}

export default new service()


